module.exports = __webpack_public_path__ + "static/media/referral-program-4.7343396e.jpg";